import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  ViewContainerRef,
  EventEmitter,
  Output
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { ParameterLoaderService } from '../parameters/parameter-loader.service';
import { NgxTwikitWebPluginService } from "@twikit/ngx-twikit-web-plugin";
import { MatDialog } from "@angular/material/dialog";
import { OrderDialogComponent } from "../order-dialog/order-dialog.component";
import { delay, filter, takeUntil, tap } from "rxjs/operators";
import { ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/product.service';

@Component({
  selector: 'app-product-configurator',
  templateUrl: './product-configurator.component.html',
  styleUrls: ['./product-configurator.component.scss']
})
export class ProductConfiguratorComponent implements AfterViewInit, OnDestroy {

  @ViewChild('visualisation', { static: false }) visualisation: ElementRef;
  @ViewChild('parametercards', { static: false, read: ViewContainerRef }) parametersCards: ViewContainerRef;

  public loaded$ = new BehaviorSubject(false);
  public saving$ = new BehaviorSubject(false);
  public unsubscribe$ = new Subject<void>();

  public products = {
    'bocciaball-table': {
      name: 'Boccia ballenhouder',
      exportUrl: 'https://cdn.twikit.com/projects/assist3d/products/bocciaballtable-9e43230f-6b14-40a7-b1dc-a75eaa118ed0/descriptors/be447d33-44b0-414b-9ccc-62dfe6dac64a.export.json'
    },
    'plug-aid': {
      name: 'Stekkerhulp',
      exportUrl: 'https://cdn.twikit.com/projects/assist3d/products/stekkerhulp-released-85812e83-63e0-4541-b5f2-17ce77051066/descriptors/5560bf32-57ff-4773-867b-83ca8138832e.export.json'
    }
  };
  private productName: string;
  private exportUrl: string;

  constructor(private readonly route: ActivatedRoute,
    private readonly twikbot: NgxTwikitWebPluginService,
    private readonly parameterLoader: ParameterLoaderService,
    private readonly dialog: MatDialog,
    private productService: ProductService) {

  }

  ngAfterViewInit(): void {
    let productKey = this.route.snapshot.paramMap.get('key');
    this.productName = this.products[productKey].name;
    this.exportUrl = this.products[productKey].exportUrl;
    this.productService.selectProduct(this.productName);

    this.twikbot.startConfigurator(productKey, this.visualisation.nativeElement)
      .then(context => context)

    this.parameterLoader.setRootViewContainerRef(this.parametersCards);
    this.twikbot.parametersData$
      .pipe(takeUntil(this.unsubscribe$)).subscribe(parameters => {
        this.loaded$.next(true);
        parameters.forEach(p => {
          this.parameterLoader.initParameter(p);
        });

        parameters.forEach(p => {
          this.parameterLoader
            .addParameter(p, value => this.twikbot.setValue(p.id, value));
        });
      }
      );
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.twikbot.stopCurrentConfigurator();
  }

  public async order() {
    this.saving$.next(true);
    let saved = await this.twikbot.saveConfigurator();

    let dialogRef = this.dialog.open(OrderDialogComponent, {
      width: '400px',
      data: {
        name: this.productName,
        configuration: {
          key: saved.configurationId,
          parameters: saved.savedData.parameters,
          resources: saved.savedData.resources
        },
        previewUrl: saved.previewUrl,
        exportUrl: this.exportUrl
      }
    });

    dialogRef.afterClosed()
      .pipe(
        tap(() => this.saving$.next(false)),
        filter(result => !!result),
        delay(4000),
        takeUntil(this.unsubscribe$),
      ).subscribe(result => {
        if (result) {
          window.location.href = '/';
        }
      });
  }

}
